import React from 'react'
import Translation from '../global/Translation'
import { injectIntl } from 'react-intl'
import { RefinementListFilter, ResetFilters, CheckboxFilter, TermsQuery, TermQuery, BoolShould, BoolMust, SelectedFilters } from 'searchkit'
import { withRouter } from 'react-router-dom'
import confirm from '../global/confirm'
import Modal from '../global/Modal'
import Select from 'react-select'
import LocalizedLink from '../global/LocalizedLink'
import FilterV2Box from './FilterV2Box'
import Button from '../global/Button'
import { getCurrentLocationSection, mapMeasure } from '../../helpers'

const CustomCheckboxItemList = (props) => {
    const { items, toggleItem, selectedItems, showCount, translate, section } = props

    return (
        <div data-qa="options" className="sk-item-list">
            {items.map(item => {
                const isChecked = selectedItems.includes(item.key)
                const label = translate ? translate(item.key) : item.key

                return (
                    <div
                        key={item.key}
                        data-qa="option"
                        data-key={label}
                        className="sk-item-list-option sk-item-list__item"
                        gtm-label={`${getCurrentLocationSection(section)}_filter_favourite-products`}
                        onClick={() => toggleItem(item.key)}
                    >
                        <input type="checkbox" data-qa="checkbox" readOnly className="sk-item-list-option__checkbox" checked={isChecked} />
                        <div data-qa="label" className="sk-item-list-option__text">
                            {label}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

const confirmChangeShippingCenter = (center, onChangeShippingCenter, intl) => {
    return confirm(intl.formatMessage({ id: 'CHANGE_SHIPPING_CENTER' })).then(
        confirm => {
            return onChangeShippingCenter(center)
        },
        cancel => {
            return Promise.reject()
        }
    )
}
const initState = {
    filtersDivStyles: {},
    selectedShippingCenter: null,
    hasSilestoneBucket: false,
    visibleFilters: 6,
    showMoreFilters: false,
    isSmallScreen: window.innerWidth <= 776,
    showClearFilter: false
}

class FiltersV2 extends React.Component {
    constructor(props) {
        super(props)

        this.state = initState
    }

    componentDidMount() {
        setInterval(() => {
            this.checkFilters()
        }, 1000)

        if (this.props.mktoolsShippingCenter)
            this.setState({ selectedShippingCenter: this.props.location.search.indexOf('mktoolShippingCenter[0]') > -1 ? this.props.mktoolsShippingCenter : null })

        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.checkFilters)
        window.removeEventListener('resize', this.handleResize)
    }

    WrappedCustomCheckboxItemList = (props) => (
        <CustomCheckboxItemList {...props} section={this.props.currentLocation.section} />
    )

    checkFilters = () => {
        let filtersArray = []

        document.querySelectorAll('.sk-selected-filters').forEach(e => {
            for (let i of e.children) {
                for (let x of i.classList) {
                    if (x.includes('selected-filter--')) {
                        let fil = x.split('selected-filter--')[1]
                        filtersArray.push(fil)
                    }
                }
            }
        })

        filtersArray = [...new Set(filtersArray)]
        filtersArray = filtersArray.filter(fil => fil !== 'type' && fil !== 'subtype')

        if (filtersArray.length > 0) {
            if (!this.state.showClearFilter) {
                this.setState({ showClearFilter: true })
            }
        } else if (this.state.showClearFilter) {
            this.setState({ showClearFilter: false })
        }

        return filtersArray
    }

    handleResize = () => {
        this.setState({ isSmallScreen: window.innerWidth <= 776 })
    }

    toggleFilters = () => {
        this.setState(prevState => ({
            showMoreFilters: !prevState.showMoreFilters
        }))
    }
    changeShippingCenter = selectedCenter => {
        this.props.setMkToolsShippingCenter(selectedCenter)
        this.setState({ selectedShippingCenter: selectedCenter })
    }

    onReset = () => {
        // this.setState({ selectedShippingCenter: null })
        if (this.props.selectedCenter === 1060)
            this.props.redirect(this.props.intl.formatMessage({ id: 'ROUTE_CATALOG' }).replace(':outlet?', '') + '?mktoolShippingCenter[0]=' + this.state.selectedShippingCenter)
    }

    noShippingCentermsg = () => {
        return <Translation id="havent_center_shipping_addres" defaultMessage="You do not have center shipping addresses, please contact your supplier" />
    }

    ShippingCenterOptions = props => {
        return (
            <div>
                {props.items && props.items.length > 0 ? (
                    <React.Fragment>
                        <Select
                            options={props.items.map(item => ({
                                label: item.name,
                                value: item.id
                            }))}
                            className={'select-shipping'}
                            value={this.state.selectedShippingCenter}
                            clearable={false}
                            onChange={selectedOption => {
                                selectedOption &&
                                    confirmChangeShippingCenter(selectedOption.value, this.changeShippingCenter, this.props.intl).then(() => {
                                        let selected = selectedOption ? [selectedOption.value] : []
                                        if (this.props.selectedCenter === 1060) props.setItems(selected)
                                        // Add the mktoolShippingCenter in url after close the modal
                                        if (!window.location.href.includes('mktoolShippingCenter[0]')) {
                                            const mktoolShippingParam = window.location.href + '&mktoolShippingCenter[0]=' + selected
                                            window.history.replaceState(null, '', mktoolShippingParam)
                                        }
                                    })
                            }}
                            placeholder={this.props.intl.formatMessage({ id: 'select' }) + '...'}
                        />
                    </React.Fragment>
                ) : (
                    this.noShippingCentermsg()
                )}
            </div>
        )
    }

    ShippingCenterOptionsWithoutFilter = options => {
        return (
            <div style={{ width: '100%' }}>
                {options && options.length > 0 ? (
                    <Select
                        options={options.map(item => ({
                            label: item.name,
                            value: item.id
                        }))}
                        value={this.state.selectedShippingCenter}
                        clearable={false}
                        onChange={selectedOption => {
                            selectedOption && confirmChangeShippingCenter(selectedOption.value, this.changeShippingCenter, this.props.intl)
                        }}
                        placeholder={this.props.intl.formatMessage({ id: 'select' }) + '...'}
                    />
                ) : (
                    this.noShippingCentermsg()
                )}
            </div>
        )
    }

    subtypeOptions = (props, subType) => {
        return (
            <Select
                options={props.items.map(item => ({ label: this.props.intl.formatMessage({ id: subType + '_' + item.key }), value: item.key }))}
                value={props.selectedItems[0]}
                onChange={selectedOption => {
                    let selected = selectedOption ? [selectedOption.value] : []
                    props.setItems(selected)
                }}
                placeholder={
                    this.props.intl.formatMessage({
                        id: 'select'
                    }) + '...'
                }
            />
        )
    }

    subtypeOptions0 = props => this.subtypeOptions(props, 'subtype')

    subtypeOptions1 = props => this.subtypeOptions(props, 'subtype_1')

    subtypeOptions2 = props => this.subtypeOptions(props, 'subtype_2')

    colorOptions = props => {
        return (
            <Select
                options={props.items.map(item => ({ label: item.key, value: item.key }))}
                value={props.selectedItems[0]}
                onChange={selectedOption => {
                    let selected = selectedOption ? [selectedOption.value] : []
                    props.setItems(selected)
                }}
                placeholder={this.props.intl.formatMessage({
                    id: 'color'
                })}
            />
        )
    }

    hideMobileFilters = () => {
        this.setState({
            filtersDivStyles: {}
        })
        document.body.classList.remove('noscroll')
    }

    finishTransform = filters => {
        if (!Array.isArray(filters)) return []

        return filters
            .filter(filter => {
                if (!filter.key) {
                    return false
                }
                return true
            })
            .map(filter => {
                filter.title = this.props.intl.formatMessage({ id: filter.key }, {}, filter.key)
                return filter
            })
            .sort((a, b) => a.key.localeCompare(b.key))
    }

    commercialFormatTransform = filters => {
        if (!Array.isArray(filters)) return []

        return filters
            .map(bucket => ({
                title: mapMeasure(bucket.key, this.props.hasImperialUnits),
                ...bucket
            }))
            .sort((a, b) => a.key.localeCompare(b.key))
    }

    outletQualityTransform = filters => {
        let result = filters
            .map(filter => {
                filter.title = this.props.intl.formatMessage({ id: 'outlet_' + filter.key.toLowerCase() })
                return filter
            })
            .sort((a, b) => a.title.localeCompare(b.title))

        return result
    }

    familyTransform = filters => {
        const MATERIAL_KEY_MAP = {
            GRANITO: 'granite',
            MARMOL: 'marble',
            TRAVERTINO: 'travertine',
            CUARCITA: 'quartzite',
            ONIX: 'onyx',
            CALIZA: 'limestone',
            ARENISCA: 'sandstone',
            GNEIS: 'gneiss',
            SOAPSTONE: 'soapstone',
        };
        return filters
            .map(filter => {
                const upperKey = filter.key.toUpperCase();
                const normalizedKey = MATERIAL_KEY_MAP[upperKey] 
                    || filter.key.toLowerCase().replace(/\s+/g, '_');

                const title = this.props.intl.messages[normalizedKey]
                    ? this.props.intl.formatMessage({ id: normalizedKey })
                    : filter.key;

                return Object.assign({}, filter, { title: title });
            })
            .sort((a, b) => a.title.localeCompare(b.title));
    };

    discontinuedTransform = filters => {
        let result = filters.map(filter => {
            filter.title = this.props.intl.formatMessage({ id: filter.key.toUpperCase() + '_SHORT' })
            return filter
        })
        return result
    }

    operationTypeTransform = filters => {
        return filters.map(filter => {
            filter.title = this.props.intl.formatMessage({ id: 'operation_type_' + filter.key.toLowerCase() })
            return filter
        })
    }

    thicknessTransform(filters) {
        if (!Array.isArray(filters)) return []
        return filters
            .map(filter => {
                filter.title = filter.key.replace('.', ',') + ' cm'
                return filter
            })
            .sort((a, b) => parseFloat(a.key) - parseFloat(b.key))
    }

    brandTransform = filters => {
        if (!Array.isArray(filters)) return []

        const typeMap = {
            SERVICES: <Translation id="operaciones" defaultMessage="Operaciones" />,
            DEKTON: this.props.selectedCenter === 7130 ? 'DKTN' : 'Dekton'
        }

        return filters.map(bucket => {
            return {
                title: typeMap[bucket.key] || bucket.key,
                ...bucket
            }
        })
    }

    typeTransform(filters) {
        if (!Array.isArray(filters)) return []

        const typeMap = {
            MK: <Translation id="mktool" defaultMessage="Marketing Tools" />,
            SH: <Translation id="showroom" defaultMessage="Showroom" />,
            WH: <Translation id="warehouse" defaultMessage="Warehouse" />,
            OPERATIONS: <Translation id="OPERATIONS" defaultMessage="Operations" />,
            SERVICE: <Translation id="SERVICE" defaultMessage="Services" />,
            '01': <Translation id="SAMPLES" defaultMessage="Samples" />,
            '02': <Translation id="OTHERS" defaultMessage="Others" />,
            '03': <Translation id="MERCHANDISING" defaultMessage="Merchandising" />,
            '04': <Translation id="LITERATURE" defaultMessage="Literature" />,
            '05': <Translation id="TAGS" defaultMessage="Tags" />,
            '06': <Translation id="ANCHORING" defaultMessage="anchoring" />,
            '07': <Translation id="BOXES" defaultMessage="Boxes" />,
            '08': <Translation id="DISPLAYS" defaultMessage="Displays" />,
            '09': <Translation id="BOOKS" defaultMessage="Books" />,
            '10': <Translation id="CABINETS" defaultMessage="Cabinets" />,
            '11': <Translation id="SIGNAGE" defaultMessage="Signage" />,
            '12': <Translation id="TEST_KITS" defaultMessage="Test kits" />,
            '13': <Translation id="WORKWEAR" defaultMessage="Workwear" />,
            '14': <Translation id="EPP" defaultMessage="EPP" />,
            '15': <Translation id="WAREHOUSE_SUPPLIES" defaultMessage="warehouse supplies" />,
            NEWS: <Translation id="NEWS" defaultMessage="NEWS" />,

            // New types
            BASIN: <Translation id="BASIN" defaultMessage="Bathroom basin" />,
            VANITY: <Translation id="VANITY" defaultMessage="Washbasin" />,
            TILE: <Translation id="TILE" defaultMessage="Tile" />,
            SLAB: <Translation id="SLAB" defaultMessage="Slab" />,
            SINK: <Translation id="SINK" defaultMessage="Kitchen sink" />,
            STRAY: <Translation id="STRAY" defaultMessage="Shower tray" />,
            CLAD: <Translation id="CLAD" defaultMessage="Cladding" />,
            FLOOR: <Translation id="FLOOR" defaultMessage="Flooring" />,
            CLAD_FLOOR: <Translation id="CLAD_FLOOR" defaultMessage="Flooring and cladding" />,
            ELAB: <Translation id="ELAB" defaultMessage="Elaborated" />,
            PAN: <Translation id="PAN" defaultMessage="Panel" />,
            'PANEL RANURADO': <Translation id="PANEL_RANURADO" defaultMessage="Slatwall panel" />,
            ACC: <Translation id="ACC" defaultMessage="Accessory" />,
            C_M: <Translation id="C_M" defaultMessage="Cleaning and maintenance" />,
            TOOL: <Translation id="TOOL" defaultMessage="Tool" />,
            AD: <Translation id="AD" defaultMessage="Adhesive" />,
            SIL: <Translation id="SIL" defaultMessage="Silicone" />,
            'T&R': <Translation id="T&R" defaultMessage="Treatment and repair" />
        }

        return filters
            .filter(bucket => typeMap[bucket.key])
            .map(bucket => ({
                title: typeMap[bucket.key],
                ...bucket
            }))
            .sort((a, b) => a.key.localeCompare(b.key))
    }

    shippingCenterTransform = filters => {
        return this.props.shippingAddressesCenters && this.props.shippingAddressesCenters.filter(center => center.id !== '1100')
    }

    subtypeTransform = data => {
        return data.map(item => {
            item.title = this.props.intl.formatMessage({ id: 'subtype_' + item.key.toLowerCase().replace(/\s/g, '_'), defaultMessage: item.key.toLowerCase() })
            return item
        })
    }

    supplyWarehouseTransform = filters => {
        const typeMap = {
            '13': <Translation id="WORKWEAR" defaultMessage="Workwear" />,
            '14': <Translation id="EPP" defaultMessage="EPP" />,
            '15': <Translation id="WAREHOUSE_SUPPLIES" defaultMessage="warehouse supplies" />
        }

        return filters.map(bucket => {
            return {
                title: typeMap[bucket.key] || bucket.key,
                ...bucket
            }
        })
    }

    colorSerieDescTransform = filters => {
        if (!Array.isArray(filters)) return []

        return filters
            .filter(bucket => bucket && bucket.key.trim() !== '')
            .map(bucket => ({
                title: bucket.key,
                ...bucket
            }))
            .sort((a, b) => a.key.localeCompare(b.key))
    }

    toneTransform = filters => {
        if (!Array.isArray(filters)) return []
        const { intl } = this.props

        const typeMap = {
            white: intl.formatMessage({ id: 'white' }),
            black: intl.formatMessage({ id: 'black' }),
            grey: intl.formatMessage({ id: 'grey' }),
            cream: intl.formatMessage({ id: 'cream' }),
            brown: intl.formatMessage({ id: 'brown' }),
            other: intl.formatMessage({ id: 'other' }),
            blue: intl.formatMessage({ id: 'blue' }),
            green: intl.formatMessage({ id: 'green' }),
            red: intl.formatMessage({ id: 'red' }),
            yellow: intl.formatMessage({ id: 'yellow' })
        }

        return filters
            .filter(bucket => bucket && bucket.key.trim() !== '')
            .map(bucket => {
                const translation = typeMap[bucket.key]
                const translatedTitle = translation || bucket.key

                return {
                    title: translatedTitle,
                    ...bucket
                }
            })
            .sort((a, b) => a.title.localeCompare(b.title))
    }

    zaddonTransform = filters => {
        if (!Array.isArray(filters)) return []

        const typeMap = {
            MAL: <Translation id="yes" defaultMessage="Yes" />,
            NO: <Translation id="no" defaultMessage="No" />
        }

        return filters
            .filter(bucket => bucket && (bucket.key === 'NO' || bucket.key === 'MAL'))
            .map(bucket => ({
                title: typeMap[bucket.key] || bucket.key,
                ...bucket
            }))
    }

    getCommercialFormatFieldName = () => {
        const LANG_TO_INDEX = {
            da: 'DA',
            de: 'DE',
            'en-US': 'EN',
            en: 'EN',
            es: 'ES',
            fi: 'FI',
            'fr-CA': 'FR',
            'en-CA': 'FR',
            fr: 'FR',
            it: 'IT',
            nl: 'NL',
            no: 'NO',
            pt: 'PT',
            pl: 'EN',
            sv: 'SV',
            tr: 'TR',
            ja: 'JA'
        }

        const locale = LANG_TO_INDEX[this.props.intl.locale] || 'EN'
        return `commercialFormat_${locale}`
    }

    render() {
        const { isSmallScreen, visibleFilters, showMoreFilters } = this.state

        let bannerSelector =
            this.props.center === 7110
                ? 'BE-' + this.props.intl.locale.toUpperCase()
                : this.props.center === 7130
                ? 'CH-' + this.props.intl.locale.toUpperCase()
                : this.props.intl.locale.toUpperCase()
        const favouritesFilter = (
            <CheckboxFilter
                id="favouriteV2"
                title={this.props.intl.formatMessage({ id: 'favourites' })}
                label={this.props.intl.formatMessage({ id: 'only_show_favourites' })}
                filter={TermsQuery('productId.raw', this.props.favouriteProducts)}
                listComponent={this.WrappedCustomCheckboxItemList}
            />
        )

        const mkToolShippingCenterFilter =
            this.props.selectedCenter === 1060 && !this.props.isMagazineMk ? (
                <div className="operationType mktools">
                    <div id="operationType-filter" className="filter-list filter-mktool-v2">
                        <RefinementListFilter
                            id="mktoolShippingCenter"
                            title={this.props.intl.formatMessage({
                                id: 'mktoolShippingCenter'
                            })}
                            field="mktoolShippingCenter.raw"
                            listComponent={this.ShippingCenterOptions}
                            bucketsTransform={this.shippingCenterTransform}
                            size={9999}
                            operator="OR"
                        />
                    </div>
                </div>
            ) : (
                this.ShippingCenterOptionsWithoutFilter(this.props.shippingAddressesCenters)
            )

        const typeFilterForMktools = !this.props.isLowesCenter && !this.props.isWarehouse && this.props.mktools && (
            <FilterV2Box
                filteredDataName="typeId"
                translatedTitle={this.props.intl.formatMessage({ id: 'type' })}
                onTransform={this.typeTransform}
                size={5}
                gtmLabel="ec_filtros_tipo"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const typeFilterGlobalHidden = (
            <FilterV2Box
                filteredDataName={'type'}
                translatedTitle={this.props.intl.formatMessage({ id: 'type' })}
                onTransform={this.typeTransform} size={5}
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        /**
         * This filter is needed for the catalog and catalog is using it.
         */
        const subTypeFilter = (
            <div style={{ display: 'none' }}>
                <RefinementListFilter
                    id="subtype"
                    title={this.props.intl.formatMessage({ id: 'subtype' })}
                    field="subtypeName.raw"
                    operator="OR"
                    bucketsTransform={this.subtypeTransform}
                    size={5}
                />
            </div>
        )

        const operationTypeFilterForIkea = this.props.isIkeaCenter && (
            <FilterV2Box
                filteredDataName="operationType"
                translatedTitle={this.props.intl.formatMessage({ id: 'OPERATIONS' })}
                onTransform={this.operationTypeTransform}
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const outletQualityFilter = ['outlet'].includes(this.props.currentLocation.section) && (
            <FilterV2Box
                filteredDataName="outletQuality"
                translatedTitle={this.props.intl.formatMessage({ id: 'outletQuality' })}
                onTransform={this.outletQualityTransform}
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        /* const discontinuedFilter = (
            <RefinementListFilter
                id="discontinued"
                title={this.props.intl.formatMessage({
                    id: 'discontinued'
                })}
                field="discontinued.raw"
                operator="OR"
                bucketsTransform={this.discontinuedTransform}
            />
        ) */

        /* const outletDeviatedFilter = this.props.selectedCenter == 1000 && (this.props.isAdmin || this.props.impersonatedBy) && (
            <CheckboxFilter
                id="outletDeviated"
                title={this.props.intl.formatMessage({
                    id: 'deviated'
                })}
                label="deviated"
                filter={BoolShould([TermQuery('outletDeviated.raw', true)])}
            />
        ) */

        /* const outletFilter = (
            <CheckboxFilter
                id="outlet"
                title={this.props.intl.formatMessage({
                    id: 'outlet'
                })}
                label="outlet"
                filter={BoolShould([TermQuery('outlet.raw', false)])}
            />
        ) */

        const webHeadingFilter = (
            <RefinementListFilter
                id="webHeading"
                title={this.props.intl.formatMessage({
                    id: 'category'
                })}
                field="webHeading.raw"
                operator="OR"
                bucketsTransform={this.typeTransform}
                orderKey="_term"
            />
        )

        const thicknessFilter = (
            <FilterV2Box
                filteredDataName="thickness"
                translatedTitle={this.props.intl.formatMessage({ id: 'thickness' })}
                onTransform={this.thicknessTransform}
                size={5}
                gtmLabel="ec_filtros_grosor"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const formatFilter = this.props.mktools && (
            <FilterV2Box
                filteredDataName="format"
                translatedTitle={this.props.intl.formatMessage({ id: 'format' })}
                onTransform={this.finishTransform}
                size={5}
                gtmLabel="ec_filtros_formato"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const commercialFormatFilter = !this.props.isLowesCenter && !this.props.isIkeaCenter && !this.props.mktools && (
            <FilterV2Box
                filteredDataName={this.getCommercialFormatFieldName()}
                translatedTitle={this.props.intl.formatMessage({ id: 'format' })}
                onTransform={this.commercialFormatTransform}
                size={5}
                gtmLabel="ec_filtros_formato"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const finishFilter = !this.props.mktools && (this.props.userType === 'ADMIN' || this.props.impersonatedBy || this.props.isIkeaCenter) && (
            <FilterV2Box
                filteredDataName="finish"
                translatedTitle={this.props.intl.formatMessage({ id: 'finish' })}
                onTransform={this.finishTransform}
                gtmLabel="ec_filtros_acabado"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const finishFamilyFilter = (
            <FilterV2Box
                filteredDataName="finishFamily"
                translatedTitle={this.props.intl.formatMessage({ id: 'finishFamily' })}
                onTransform={this.finishTransform}
                gtmLabel="ec_filtros_familia_acabados"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const brandFilter = (
            <FilterV2Box
                filteredDataName="brand"
                translatedTitle={this.props.intl.formatMessage({ id: 'brands' })}
                onTransform={this.brandTransform}
                gtmLabel="ec_filtros_marcas"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const familyFilter = !this.props.mktools && !this.props.isLowesCenter && !this.props.isWarehouse && !this.props.isIkeaCenter && (
            <FilterV2Box
                filteredDataName="family"
                translatedTitle={this.props.intl.formatMessage({ id: 'stone_families' , defaultMessage: 'Stone families'})}
                onTransform={this.familyTransform}
                gtmLabel="ec_filtros_familia_piedras"
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        /* const promoFilter = (
            <div style={{ display: 'none' }}>
                <CheckboxFilter
                    id="promo"
                    title={this.props.intl.formatMessage({
                        id: 'promotion'
                    })}
                    field="promo.raw"
                    operator="OR"
                    label="promotion"
                    filter={BoolShould([TermQuery('promo.raw', true)])}
                />
            </div>
        ) */

        const supplyWarehouseFilter = !this.props.isLowesCenter && this.props.isWarehouse && (
            <FilterV2Box
                filteredDataName="typeId"
                translatedTitle={this.props.intl.formatMessage({ id: 'WAREHOUSE_SUPPLIES' })}
                onTransform={this.supplyWarehouseTransform}
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const colorSerieDescFilter = !this.props.mktools && !this.props.isIkeaCenter && (
            <FilterV2Box
                filteredDataName="colorSerieDesc"
                translatedTitle={this.props.intl.formatMessage({ id: 'collection' })}
                onTransform={this.colorSerieDescTransform}
                size={5}
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const toneFilter = !this.props.mktools && !this.props.isIkeaCenter && (
            <FilterV2Box
                filteredDataName="tone"
                translatedTitle={this.props.intl.formatMessage({ id: 'tone' })}
                onTransform={this.toneTransform}
                size={5}
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        const zaddonFilter = !this.props.mktools && !this.props.isIkeaCenter && (
            <FilterV2Box
                filteredDataName="zaddon"
                translatedTitle={this.props.intl.formatMessage({ id: 'MAL' })}
                onTransform={this.zaddonTransform}
                size={5}
                operator={'AND'}
                triggerCatalogFilter={this.props.triggerCatalogFilter}
                sectionType={getCurrentLocationSection(this.props.currentLocation.section)}
            />
        )

        //All filters
        const allFilters = [
            typeFilterForMktools,
            brandFilter,
            thicknessFilter,
            finishFilter,
            finishFamilyFilter,
            commercialFormatFilter,
            formatFilter,
            colorSerieDescFilter,
            toneFilter,
            supplyWarehouseFilter,
            operationTypeFilterForIkea,
            zaddonFilter,
            familyFilter,
            outletQualityFilter,
            //outletDeviatedFilter,
            //outletFilter,
            //promoFilter,
        ].filter(Boolean)

        return (
            <div>
                <div className="catalog__group_filters_options" data-cy="catalog__group_filters_options v2">
                    {this.props.mktools && this.props.isLogged && !this.state.selectedShippingCenter && this.props.userType === 'ADMIN' && (
                        <div className="container">
                            <Modal
                                customClass="showOverflow"
                                title={<Translation id="please_select_shipping_center" defaultMessage="Please select shipping center" />}
                                showCloseButton={false}
                            >
                                {this.props.isLoadingShippingAddresses ? (
                                    <Translation id="loading_shipping_addresses" defaultMessage="Loading Shipping Addresses" />
                                ) : (
                                    <div className={this.props.mktools ? 'filters__contain mktools' : 'filters__contain'}>{mkToolShippingCenterFilter}</div>
                                )}
                            </Modal>
                        </div>
                    )}
                    {this.props.hasPromoActivated &&
                        (this.props.promoBanners[bannerSelector] || this.props.promoBanners['default'].catalogBanner) &&
                        !this.props.location.search.includes('promo') && (
                            <div className="">
                                <LocalizedLink routeId="ROUTE_CATALOG" queryString="?type[0]=SLAB&promo=true" params={{ outlet: '' }}>
                                    <div className="d-block d-md-none">
                                        <img
                                            src={
                                                this.props.promoBanners[bannerSelector]
                                                    ? this.props.promoBanners[bannerSelector].homeBannerMobile
                                                    : this.props.promoBanners['default'].homeBannerMobile
                                            }
                                            style={{ width: '100%' }}
                                            alt=""
                                            extraClass=" image-slide"
                                        />
                                    </div>
                                    <div className="d-none d-md-block">
                                        <img
                                            src={
                                                this.props.promoBanners[bannerSelector]
                                                    ? this.props.promoBanners[bannerSelector].homeBannerMobile
                                                    : this.props.promoBanners['default'].homeBannerMobile
                                            }
                                            style={{ width: '100%' }}
                                            alt=""
                                            extraClass=" image-slide"
                                        />
                                    </div>
                                </LocalizedLink>
                                <br />
                            </div>
                        )}

                    {
                        <span
                            className="filter-responsive"
                            onClick={() => {
                                ;[...document.querySelectorAll('#filters')].forEach(e => {
                                    e.hidden = !e.hidden
                                    e.style.display = 'flex'
                                    ;[...document.querySelectorAll('#show-filters')].map(i => (i.hidden = !e.hidden))
                                    ;[...document.querySelectorAll('#hide-filters')].map(i => (i.hidden = e.hidden))
                                })
                            }}
                        >
                            <strong id="show-filters">
                                <Translation id="show_filters" defaultMessage="Show filters" />
                            </strong>
                            <strong hidden id="hide-filters">
                                <Translation id="hide_filters" defaultMessage="Hide filters" />{' '}
                            </strong>
                            <i className="fas fa-filter fa-xs"></i>
                        </span>
                    }

                    <div className="filters" id="filters" hidden={window.innerWidth < 776}>
                        {this.props.mktools && (
                            <div style={{ display: 'none' }} className="row no-gutters">
                                <div className="col-12">{webHeadingFilter}</div>
                            </div>
                        )}

                        <div className={this.props.mktools ? 'filters__contain mktools' : 'filters__contain'}>
                            <div className="first-line">
                                <div className="filter-content">
                                    <div className="filter-items">
                                        <div className="filter-items--child">
                                            {allFilters && allFilters.map((filter, index) => {
                                                // En pantallas grandes, aplicar la lógica de ocultar los filtros
                                                if (!isSmallScreen) {
                                                    return (
                                                        <div key={index} className={`filter-item ${!showMoreFilters && index >= visibleFilters ? 'hidden-filter' : ''}`}>
                                                            {filter}
                                                        </div>
                                                    )
                                                }

                                                // En pantallas pequeñas, mostrar todos los filtros sin restricciones
                                                return (
                                                    <div key={index} className="filter-item">
                                                        {filter}
                                                    </div>
                                                )
                                            })}

                                            {allFilters && allFilters.length > visibleFilters && (
                                                <div className="catalog-toggle-filters">
                                                    <Button icon="filter" onClick={this.toggleFilters} className="catalog-toggle-filters--btn">
                                                        {showMoreFilters ? (
                                                            <Translation id="less_filters" defaultMessage="Less filters" />
                                                        ) : (
                                                            <Translation id="more_filters" defaultMessage="More filters" />
                                                        )}
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {subTypeFilter}
                                    <div>
                                        {this.props.isLogged && this.props.favouriteProducts && (
                                            <div className="contain-favourites" onClick={() => this.props.filterFavourites()}>
                                                <div>{favouritesFilter}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.props.selectedCenter === 7777 && (
                                    <div>
                                        <span>
                                            For assistance please email <a href="mailto:lowescustomercare@cosentino.com">lowescustomercare@cosentino.com</a>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* DO NOT DELETE THIS FILTER IF YOU DON'T KNOW WHAT YOU'RE DOING. IS REQUIRED FOR FILTER BY TYPES */}
                        <div className="d-none">{typeFilterGlobalHidden}</div>
                        <div className="tags_clean">
                            <SelectedFilters itemComponent={CustomFilterItem(this.props.hasImperialUnits)} />
                            {this.state.showClearFilter && <ResetFilters component={<ClearFiltersDesktop onReset={this.onReset} />} />}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(injectIntl(FiltersV2))

const ClearFiltersDesktop = ({ hasFilters, translate, resetFilters, onReset }) => (
    <span
        size="small"
        icon="trash"
        hidden={!hasFilters}
        className="clean-filters"
        onClick={() => {
            resetFilters()
            onReset()
        }}
        datacy="catalog__clear_all_filters"
    >
        {translate('reset.clear_all')}
    </span>
)

const CustomFilterItem = (hasImperialUnits) => ({ filterId, labelKey, labelValue, removeFilter, translate }) => {
    /* README: If you want to add a new translation, make sure to define that translation in the SearchKit translations object, it's on Catalog.js */

    // Define a map to handle logic for different filterIds
    const logicMap = {
        zaddon: value => {
            if (value === 'MAL') {
                return translate('yes') || 'Yes'
            } else if (!value) {
                return translate('no') || 'No'
            }
            return value
        },
        outletQuality: value => {
            if (value === 'O') {
                return translate('outlet_o') || 'Outlet Basic'
            } else if (value === 'V') {
                return translate('outlet_v') || 'Outlet Premium'
            } else if (value === 'X') {
                return translate('outlet_x') || 'Outlet Exclusive'
            } else if (value === 'W') {
                return translate('outlet_w') || 'Outlet Premium Plus'
            }
            return value
        },
        commercialFormat: value => {
            return mapMeasure(value, hasImperialUnits)
        }
        /* commercialFormat: (value) => {
            if (value === '') {
                return translate('without_format') || 'Without format'
            }
            return value
        } */
    }

    // Fallback for unknown filterIds or default logic
    const defaultHandler = value => value || ''

    // Get the display label based on the logic map
    const getDisplayLabel = () => {
        if (filterId.startsWith('commercialFormat')) filterId = 'commercialFormat'
        const handler = logicMap[filterId] || defaultHandler
        return handler(labelValue)
    }

    //RESPECT THE HTML STRUCTURE. checkFilters METHOD DEPENDS ON.

    return (
        <div className={`sk-selected-filters-option sk-selected-filters__item selected-filter--${filterId}`}>
            <div className="sk-selected-filters-option__name">
                {labelKey + ': '}
                <span>{getDisplayLabel()}</span>
            </div>
            <div className="sk-selected-filters-option__remove-action" onClick={() => removeFilter()}>
                x
            </div>
        </div>
    )
}
